import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth';
import { getApiKey, clearApiKey } from './apiKey';
import { API } from './api';

// The session rides in a cookie, so it has to go with every call.
axios.defaults.withCredentials = true;

// The shared key is the OLD way in, kept only for the window before Google
// sign-in is switched on. Once it is on the key must not be sent from a
// browser at all: it authenticates as a machine, so anyone still holding it
// would walk straight past the login and every permission behind it.
//
// The app is mounted after this settles, so no request can go out under the
// wrong identity while the answer is still in flight.
(async () => {
  let enabled = false;
  try {
    enabled = (await axios.get(`${API}/api/auth/config`)).data.enabled === true;
  } catch (e) { /* treat as off and fall back to the key */ }

  if (enabled) {
    clearApiKey();
    delete axios.defaults.headers.common['x-api-key'];
  } else {
    axios.defaults.headers.common['x-api-key'] = getApiKey();
  }

  // While sign-in is on, a 401 just means "not signed in" — the login screen
  // is already what gets rendered, so there is nothing to shout about.
  axios.interceptors.response.use(null, (error) => {
    if (error.response && error.response.status === 401 && !enabled) {
      clearApiKey();
      alert('Access key is wrong or missing. Reload the page and enter it again.');
    }
    return Promise.reject(error);
  });

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
